<template>
  <q-select
    v-model="selectSupplier"
    :options="filterOptions"
    outlined
    dense
    clearable
    emit-value
    use-input
    map-options
    :disable="props.disabled"
    :loading="isLoading"
    v-bind="!selectSupplier && { placeholder: '選択してください' }"
    style="background: var(--q-white); padding: 0"
    :rules="props.isValidate ? [(val) => !!val || $t('validation.required')] : undefined"
    @filter="filterFn"
  >
    <template #no-option>
      <q-item>
        <q-item-section class="text-grey">該当するサプライヤはありません</q-item-section>
      </q-item>
    </template>
  </q-select>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from '../../common/axios-common';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';

interface Props {
  supplier: string;
  // validate有無
  isValidate?: boolean;
  disabled?: boolean;
}

interface SupplierSelect {
  label: string;
  value: string;
}

const props = withDefaults(defineProps<Props>(), {
  isValidate: false,
  disabled: false,
});

const router = useRouter();
const emit = defineEmits(['selectSupplier']);

// プルダウン
const options = ref<SupplierSelect[]>([]);
// プルダウン（フィルター用）
const filterOptions = ref(options.value);
// Loading
const isLoading = ref(false);

// サプライヤ選択値
const selectSupplier = computed({
  get: () => props.supplier,
  set: (value) => {
    emit('selectSupplier', value || '');
  },
});

/**
 * サプライヤリスト取得
 */
const getSupplier = () => {
  // Loading Start
  isLoading.value = true;

  axios
    .post('/suppliers')
    .then((res) => {
      const { common, supplierSelectItems } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          supplierSelectItems.forEach(
            (supplier: { supplier_name: string; supplier_code: string }) => {
              options.value.push({
                label: `${supplier.supplier_code}: ${supplier.supplier_name}`,
                value: supplier.supplier_code,
              });
            }
          );
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      isLoading.value = false;
    });
};
// プルダウンフィルター
const filterFn = (val: string, update: (arg0: () => void) => void) => {
  update(() => {
    if (val === '') {
      filterOptions.value = options.value;
    } else {
      const needle = val.toLowerCase();
      filterOptions.value = options.value.filter(
        (v: { label: string; value: string }) =>
          v.label.toLowerCase().indexOf(needle) > -1 || v.value.toLowerCase().indexOf(needle) > -1
      );
    }
  });
};

/**
 * 初期表示処理
 */
getSupplier();
</script>
